export default __webpack_public_path__ + "static/media/1902.06571e1e.png";